var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bounce"}},[(_vm.showBadge)?_c('badge',[_vm._v(_vm._s(_vm.dealCount))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }